export default __webpack_public_path__ + "static/logoticker_cosmo-d222750faf64c8863ede576048b35918.svg";